export default __webpack_public_path__ + "img/Poppins-Medium_feec26f.woff";